module.exports = __webpack_public_path__ + "static/media/noun-bank-card-approve-524377-142350.4f2fbad6.svg";